import { ActionWithHttpStatusModel } from '../model/action-with-http-status.model';

export function isActionWithPayloadDataModel(
  action: unknown,
): action is ActionWithHttpStatusModel {
  const typedAction = action as ActionWithHttpStatusModel;
  return 'payload' in typedAction && 'status' in typedAction.payload;
}
